import { ITaxTerminal, IPostTerminalResponse } from '../models/terminal.interface';
import PostToApi from './route-helpers/api-post';

/**
 * Updated linked tax list to a terminal
 * 
 * @param {ITaxTerminal} taxTerminal the list of taxes to be linked to a terminal
 * 
 * @returns {IPostTerminalResponse} the api response | error
 */
export const postTerminalTax = async ( taxTerminal: ITaxTerminal ): Promise<IPostTerminalResponse> => {
  const modelData = {
    terminalId: taxTerminal.terminalID,
    taxArray: taxTerminal.taxIdArray
  };

  const endpoint = `/terminal/${taxTerminal.terminalID}/tax`;
  const errorMessage = 'Error linking tax to terminal';

  return PostToApi(endpoint, modelData, errorMessage);
}

